import { useTranslation } from 'react-i18next';
export default function ContactInfoSection() {

  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t("contact.getInTouch", { defaultValue: "Get In Touch" })}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          {t('contact.contactOutPro')} </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Office Address */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-building-line text-2xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('contact.officeAddress')}</h3>
            <div className="space-y-2 text-gray-600">
              <p className="font-medium">GOLD LABEL GLOBAL LIMITED</p>
              <p>{t("contact.addressFloor", { defaultValue: "Room 3404-3406, 34/F." })}</p>
              <p>China Resources Building</p>
              <p>26 Harbour Road, Wanchai</p>
              <p>{t("contact.hongKong", { defaultValue: "Hong Kong" })}</p>
            </div>
            <div className="mt-6">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                <i className="ri-time-line mr-1"></i>
               {t('contact.bussHour')} 
              </span>
            </div>
          </div>

          {/* Phone Contact */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-phone-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('contact.phoneSupp')}</h3>
            <div className="space-y-4">
              <div>
                <p className="text-gray-600 mb-2">{t('contact.mainOffice')}</p>
                <a href="tel:+85230083082" className="text-2xl font-bold text-blue-600 hover:text-blue-700 transition-colors cursor-pointer">
                  +852 3008 3082
                </a>
              </div>
              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm text-gray-500 mb-2">{t('contact.availableServices')}</p>
                <ul className="space-y-1 text-sm text-gray-600">
                  <li>• {t('contact.accOpenSup')}</li>
                  <li>• {t('contact.tradSup')}</li>
                  <li>• {t('contact.techSup')}</li>
                  <li>• {t('contact.genInq')}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Email Contact */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-mail-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">{t('contact.emailSup')}</h3>
            <div className="space-y-4">
              <div>
                <p className="text-gray-600 mb-2">{t('contact.genSup')}</p>
                <a href="mailto:support@jlbhk.com" className="text-xl font-semibold text-green-600 hover:text-green-700 transition-colors cursor-pointer break-all">
                  support@jlbhk.com
                </a>
              </div>
              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm text-gray-500 mb-2">{t('contact.responseTime')}</p>
                <div className="space-y-1 text-sm text-gray-600">
                  <p>• {t('contact.genInq24')}</p>
                  <p>• {t('contact.techSup24')}</p>
                  <p>• {t('contact.accIss24')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Contact Methods */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-4">{t('contact.needImSup')}</h3>
              <p className="text-orange-100 mb-6">{t('contact.needImSup.desc')} </p>
              <div className="flex flex-wrap gap-4">
                <a href="tel:+85230083082" className="bg-white text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>
                  {t('contact.callNow')}
                </a>
                <a href="mailto:support@jlbhk.com" className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-mail-line mr-2"></i>
                 {t('contact.sendEmail')}
                </a>
              </div>
            </div>
            <div className="text-center">
              <div className="w-32 h-32 bg-white/20 rounded-full flex items-center justify-center mx-auto">
                <i className="ri-customer-service-2-line text-5xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
